module.exports = __webpack_public_path__ + "img/B.60a8d71e.webp";